function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
}

export function scrollTo(duration = 1, targetY = 0) {
    const startY = window.pageYOffset;
    const startTime = performance.now();
    const distance = targetY - startY;

    function animate(currentTime) {
        const elapsed = (currentTime - startTime) / 1000; // Convert to seconds
        const progress = Math.min(elapsed / duration, 1);
        
        const easeProgress = easeInOutQuart(1 - progress);
        window.scrollTo(0, targetY - easeProgress * distance);

        if (progress < 1) {
            requestAnimationFrame(animate);
        }
    }

    requestAnimationFrame(animate);
}

export function scrollToTop(duration = 1) {
    scrollTo(duration, 0);
}